export interface TimesheetLockSummary {
  locked: number;
  ready: number;
  unavailable: number;
  unknown: number;
  total: number;
}

interface TimesheetLockState {
  locked: boolean;
  available?: boolean;
}

interface BulkLockResult {
  locked: number;
  skipped: number;
  failed: number;
  results?: Array<{
    userId: number | string;
    name: string;
    locked: boolean;
    skipped: boolean;
    error: string;
  }>;
}

export const summarizeTimesheetLocks = (
  states: readonly (TimesheetLockState | undefined)[],
): TimesheetLockSummary =>
  states.reduce<TimesheetLockSummary>(
    (summary, state) => {
      if (!state) summary.unknown += 1;
      else if (state.locked) summary.locked += 1;
      else if (state.available === true) summary.ready += 1;
      else summary.unavailable += 1;
      return summary;
    },
    { locked: 0, ready: 0, unavailable: 0, unknown: 0, total: states.length },
  );

export const formatBulkLockFeedback = (result: BulkLockResult) => {
  const details = (result.results ?? [])
    .filter((item) => item.error.trim().length > 0)
    .map((item) => `${item.name}: ${item.error}`);
  return {
    tone: details.length > 0 ? ("error" as const) : ("success" as const),
    summary: `${result.locked} locked · ${result.skipped} already locked · ${result.failed} failed.`,
    details,
  };
};
